export default "__VITE_ASSET__CPHH75Zi__$_?nuxt_component=async&nuxt_component_name=Svgo经济舱&nuxt_component_export=default__"